import { useContext, useEffect, useState } from "react";

import ApartmentIcon from "@material-ui/icons/Apartment";
import Grid from "@material-ui/core/Grid";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Title from "../../components/basics/Title";
import TabsErp from "../../components/tabs/TabsErp";
import { ClienteContext } from "../../context/ClienteContext";
import TextFieldErp from "../../components/basics/TextFieldErp";
import SelectErp from "../../components/basics/SelectErp";
import ButtonErp from "../../components/basics/ButtonErp";
import Loading from "../../components/basics/Loading";
import useClienteController from "./ClienteController";
import { ImutaveisContext } from "../../context/ImutaveisContext";
import ModalCertificado from "./ModalCertificado";
import "./Cliente.css";

export default function CadastroCliente() {
  const [tabIndex, setTabIndex] = useState(0);
  const { handleSubmit, handleCancel } = useClienteController();
  const { loading } = useContext(ClienteContext);
  const headers = [
    {
      label: "Dados cadastrais",
    },
    {
      label: "Endereço",
    },
  ];

  const children = [<TabDados key="0" />, <TabEndereco key="1" />];

  return (
    <>
      <Loading open={loading} />
      <div className="fluid-container">
        <div className="container">
          <Title titulo="Cadastro de Clientes" icon={ApartmentIcon} />
          <TabsErp
            headers={headers}
            children={children}
            tabIndex={tabIndex}
            onChange={(event, value) => {
              if (Number.isInteger(value)) setTabIndex(value);
            }}
          />
          <Grid
            container
            justify="flex-end"
            style={{
              background: "white",
              borderRadius: "0px 0px 10px 10px",
              padding: 10,
            }}
          >
            <ButtonErp cancel onClick={handleCancel} />
            <ButtonErp save onClick={handleSubmit} />
          </Grid>
        </div>
      </div>
    </>
  );
}

function TabDados() {
  const {
    handleNumInscricao,
    handleTipoInscricao,
    handleNumInscricaoEstadual,
    handleNumInscricaoMunicipal,
    handleCcm,
    handleNome,
    handleEmail,
    handleChangeCheckContador,
    handleChangeCheckCliente,
  } = useClienteController();
  const {
    tipoInscricao,
    numInscricao,
    numInscricaoEstadual,
    numInscricaoMunicipal,
    ccm,
    nome,
    email,
    checkboxCertificado,
    openModalCertificado,
    errors,
  } = useContext(ClienteContext);

  return (
    <>
      {openModalCertificado && <ModalCertificado />}
      <Grid
        container
        style={{
          background: "white",
          borderRadius: "10px 10px 0px 0px",
          padding: 10,
        }}
      >
        <Grid container spacing={2}>
          <Grid item lg={2} md={6} sm={6} xs={12}>
            <SelectErp
              helperText={errors.tipoInscricao || ""}
              error={errors.tipoInscricao ? true : false}
              label="Tipo de Inscrição"
              lg={2}
              value={tipoInscricao}
              onChange={handleTipoInscricao}
              optionsList={[{ descricao: "CNPJ" }, { descricao: "CPF" }]}
              descriptionField="descricao"
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TextFieldErp
              disabled={!tipoInscricao}
              helperText={errors.numInscricao}
              error={errors.numInscricao ? true : false}
              value={numInscricao}
              onChange={(e) =>
                handleNumInscricao({
                  prop: e,
                  tipoInscricaoProp: tipoInscricao,
                })
              }
              label="N° Inscrição*"
            />
          </Grid>

          <Grid item lg={4} md={4} sm={4} xs={12}>
            <TextFieldErp
              helperText={errors.numInscricaoEstadual || ""}
              error={errors.numInscricaoEstadual ? true : false}
              value={numInscricaoEstadual}
              onChange={handleNumInscricaoEstadual}
              label="N° Inscrição Estadual"
            />
          </Grid>

          <Grid item lg={2} md={4} sm={4} xs={12}>
            <TextFieldErp
              helperText={errors.numInscricaoMunicipal || ""}
              error={errors.numInscricaoMunicipal ? true : false}
              value={numInscricaoMunicipal}
              onChange={handleNumInscricaoMunicipal}
              label="N° Inscrição Municipal"
            />
          </Grid>

          <Grid item lg={2} md={4} sm={4} xs={12}>
            <TextFieldErp
              helperText={errors.ccm || ""}
              error={errors.ccm ? true : false}
              value={ccm}
              onChange={handleCcm}
              label="CCM"
            />
          </Grid>

          <Grid item lg={8} md={12} sm={12} xs={12}>
            <TextFieldErp
              helperText={errors.nome || ""}
              error={errors.nome ? true : false}
              value={nome}
              onChange={handleNome}
              label="Nome do Estabelecimento*"
            />
          </Grid>

          <Grid item lg={4} md={12} sm={12} xs={12}>
            <TextFieldErp
              helperText={errors.email}
              error={errors.email ? true : false}
              value={email}
              onChange={handleEmail}
              label="E-mail Principal*"
            />
          </Grid>

          <Grid item flex={1}>
            <Grid
              item
              xs={9}
              container
              spacing={1}
              alignItems="center"
              justify="space-between"
            >
              <Grid item xs={12}>
                Certificado Digital
              </Grid>

              <Grid
                item
                container
                justify="center"
                className="container-checkbox"
                spacing={1}
              >
                <Grid
                  item
                  xs={6}
                  container
                  alignItems="center"
                  justify="center"
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkboxCertificado.contador}
                        onChange={handleChangeCheckContador}
                        name="contador"
                        color="primary"
                      />
                    }
                    label="Contador"
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  container
                  alignItems="center"
                  justify="center"
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkboxCertificado.cliente}
                        onChange={handleChangeCheckCliente}
                        name="cliente"
                        color="primary"
                      />
                    }
                    label={
                      <Grid
                        container
                        alignItems="center"
                        justify="center"
                        spacing={1}
                      >
                        <Grid item xs={7}>
                          Cliente
                        </Grid>

                        <Grid item xs={5}>
                          <CloudUploadIcon className="icon-cloud" />
                        </Grid>
                      </Grid>
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

function TabEndereco() {
  const [optionsFilterMunicipio, setOptionsFilterMunicipio] = useState([]);
  const {
    handlePais,
    handleCep,
    handleUf,
    handleCidade,
    handleLogradouro,
    handleComplemento,
    handleBairro,
  } = useClienteController();
  const { pais, cep, uf, cidade, logradouro, complemento, bairro, errors } =
    useContext(ClienteContext);
  const {
    optionsPais,
    optionsEstado,
    optionsMunicipio,
    loadingInputsImutaveis,
  } = useContext(ImutaveisContext);

  useEffect(() => {
    setOptionsFilterMunicipio(optionsMunicipio);
  }, [optionsMunicipio]);

  useEffect(() => {
    if (!cidade || !uf || cidade.estado_codigo !== uf.codibge) {
      handleCidade(null);
    }

    setOptionsFilterMunicipio(
      uf
        ? optionsMunicipio.filter((opt) => opt.estado_codigo === uf.codibge)
        : optionsMunicipio
    );
  }, [uf, cidade, optionsMunicipio, handleCidade]);

  return (
    <>
      <Grid
        container
        style={{
          background: "white",
          borderRadius: "10px 10px 0px 0px",
          padding: 10,
        }}
      >
        <Grid container spacing={2}>
          <Grid item lg={9} md={9} sm={6} xs={6}>
            <SelectErp
              loading={loadingInputsImutaveis.optionsPais || false}
              helperText={errors.pais || ""}
              error={errors.pais ? true : false}
              label="País*"
              value={pais}
              onChange={handlePais}
              optionsList={optionsPais}
              descriptionField="descricao"
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={6}>
            <TextFieldErp
              helperText={errors.cep || ""}
              error={errors.cep ? true : false}
              value={cep}
              onChange={handleCep}
              label="CEP*"
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={6}>
            <SelectErp
              loading={loadingInputsImutaveis.optionsEstado || false}
              helperText={errors.uf || ""}
              error={errors.uf ? true : false}
              label="UF*"
              value={uf}
              onChange={handleUf}
              optionsList={optionsEstado}
              descriptionField="nome"
            />
          </Grid>

          <Grid item lg={8} md={8} sm={6} xs={6}>
            <SelectErp
              loading={loadingInputsImutaveis.optionsMunicipio || false}
              helperText={errors.cidade || ""}
              error={errors.cidade ? true : false}
              label="Cidade*"
              value={cidade}
              onChange={handleCidade}
              optionsList={optionsFilterMunicipio}
              descriptionField="municipio"
            />
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12}>
            <TextFieldErp
              helperText={errors.logradouro || ""}
              error={errors.logradouro ? true : false}
              value={logradouro}
              onChange={handleLogradouro}
              label="Logradouro*"
            />
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12}>
            <TextFieldErp
              helperText={errors.complemento || ""}
              error={errors.complemento ? true : false}
              value={complemento}
              onChange={handleComplemento}
              label="Complemento"
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldErp
              helperText={errors.bairro || ""}
              error={errors.bairro ? true : false}
              value={bairro}
              onChange={handleBairro}
              label="Bairro*"
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
